import store from "../../redux/redux";
import {
  setHideModalCloseBtn,
  setIsNewModal,
  setModal,
  setOnModalBack,
  setOnModalClose,
} from "../../redux/slices/appSlice";
import { ModalPage, ModalPageProps } from "../../_Web/components/Modal/Modal";
import { toggleScrolling } from "./generic";
import { NewModalPage } from "../../_Web/components/Modal/NewModal";

type modalConfig = {
  hideModalCloseBtn?: boolean;
  onBack?: Function;
  onClose?: Function;
  isNew?: boolean;
};

export function openModal(props: ModalPageProps, config: modalConfig = {}) {
  const modal =
    config.isNew === true ? (
      <NewModalPage
        content={props.content}
        small={props.small}
        style={props.style}
        cancelButton={props.cancelButton}
        className={props.className}
        native={props.native}
      />
    ) : (
      <ModalPage
        content={props.content}
        small={props.small}
        style={props.style}
        cancelButton={props.cancelButton}
        className={props.className}
        native={props.native}
      />
    );

  store.dispatch(setModal(modal));
  store.dispatch(setHideModalCloseBtn(config.hideModalCloseBtn === true));
  store.dispatch(setIsNewModal(config.isNew === true));
  store.dispatch(setOnModalBack(config.onBack));
  store.dispatch(setOnModalClose(config.onClose));
  toggleScrolling(false);
}

export function setModalVariables(props: {
  hideModalCloseBtn?: boolean;
  onBack?: Function;
  onClose?: Function;
}) {
  if (typeof props.hideModalCloseBtn !== "undefined")
    store.dispatch(setHideModalCloseBtn(props.hideModalCloseBtn));

  if (props.onBack) store.dispatch(setOnModalBack(props.onBack));
  if (props.onClose) store.dispatch(setOnModalClose(props.onClose));
}

export function closeModal() {
  store.dispatch(setModal(null));
  toggleScrolling(true);
}
